import axios from "axios";
import { config } from "./config.service";

const instance = axios.create({
  // baseURL: "https://demo.thaipower.co/",
  baseURL: config.host_api,
  headers: {
    "Content-Type": "application/json",
  },
});

export default instance;
